<modal-component class="_event-type-component">
	
	<!-- LEFT-->
	<ng-container left>
		<div class="_header">
			<ng-container *ifUserHasPermissions="[UserPermissions.WriteConfigurations]">
				<p *ngIf="action === 'create'" class="_title" [translate]="'EVENT_TYPE.CREATE'"></p>
				<p *ngIf="action === 'update'" class="_title" [translate]="'EVENT_TYPE.EDIT'"></p>
			</ng-container>
			<ng-container *ifUserHasNotPermissions="[UserPermissions.WriteConfigurations]">
				<p class="_title" [translate]="'EVENT_TYPE.READ'"></p>
			</ng-container>
			<p class="_subtitle">{{eventTypeForm?.get('name').value}}</p>
		</div>
		<!-- info or context -->
	</ng-container>

	
	<!-- RIGHT -->
	<ng-container right>		
		<form [formGroup]="eventTypeForm" [disable-form-if-not-permission]="[UserPermissions.WriteConfigurations]">

			<form-input label="{{ 'EVENT_TYPE.NAME' | translate }}" [formControl]="eventTypeForm.get('name') | cast"></form-input>

			<form-textarea label="{{ 'EVENT_TYPE.DESCRIPTION' | translate }}" [formControl]="eventTypeForm.get('description') | cast"></form-textarea>

		</form>
	</ng-container>

	<!-- BUTTONS -->
	<ng-container buttons >	
		<ng-container *ifUserHasPermissions="[UserPermissions.WriteConfigurations]">
			<button (click)="delete()" class="_button _delete-button" *ngIf="action === 'update'" >
				<span [translate]="'EVENT_TYPE.DELETE'"></span>
			</button>
			<button (click)="createOrUpdate()" class="_button _save-button">
				<span *ngIf="action === 'create'" [translate]="'EVENT_TYPE.CREATE'"></span>
				<span *ngIf="action === 'update'" [translate]="'EVENT_TYPE.UPDATE'"></span>
			</button>
		</ng-container>	
		<button class="_button _cancel-button" [translate]="'EVENT.CANCEL'" (click)="close()"></button>
	</ng-container>	


</modal-component>